<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <breadcrumb></breadcrumb>
    <div style="position: absolute; right: 30px; top: 2px; font-size: 14px">
      <router-link
        class="inlineBlock"
        to="/helpCenter"
        style="
          text-align: right;
          color: #fff;
          font-size: 16px;
          margin-right: 16px;
        "
        >帮助中心</router-link
      >
      <el-dropdown trigger="click">
        <div
          class="avatar-wrapper"
          style="display: flex; align-items: center; cursor: pointer"
        >
          <!-- <img class="user-avatar" :src="avatar"> -->

          <div style="font-size: 18px; color: #fff">
            {{ $store.getters.name.name }}
          </div>

          <i class="el-icon-caret-bottom" style="color: #fff"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <!-- <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link> -->
          <router-link class="inlineBlock" to="/updatePassWord">
            <el-dropdown-item> 修改密码 </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters([
      "sidebar",
      // 'avatar'
    ]),
  },
  mounted() {
    // //console.log(this.$store)
  },
  methods: {
    toggleSideBar() {
      // this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
        // sessionStorage.setItem('keyPath', '/ums-home/');

        sessionStorage.clear();
      });
   
    },
  },
};
</script>
<style >
.el-menu {
  background: #409eff;
  color: #fff;
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  position: fixed;
  height: 50px;
  width: calc(100vw - 180px);
  z-index:99;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -24px;
        top: 12px;
        font-size: 24px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue